angular.module('checkout').service(
    'allowedStates',
    [
        '$http',
        'rcmLoading',
        'rcmApiLibMessageService',
        function ($http, rcmLoading, rcmApiLibMessageService) {
            let cachedCountries = {};
            let self = this;
            /**
             * getStates
             * @param country
             * @param callback
             */
            self.getStates = function (country, callback) {
                //If this is the second request, just pull from cache
                if (country in cachedCountries) {
                    callback(cachedCountries[country]);
                    return;
                }

                rcmLoading.setLoading('checkout.allowedStates', 0);
                //If we don't have in cache, get from server
                $http(
                    {
                        method: 'GET',
                        url: '/api/resource/state?filter[where][country]=' + country + '&filter[order][name]=ASC',
                    }
                ).success(
                    function (data) {
                        cachedCountries[country] = data;
                        rcmLoading.setLoading('checkout.allowedStates', 1);
                        callback(data);
                    }
                ).error(
                    function (data, status) {
                        rcmLoading.setLoading('checkout.allowedStates', 1);
                        rcmApiLibMessageService.setMessage(
                            {
                                type: 'http',
                                source: 'checkoutAllowedStates',
                                error: status,
                            }
                        );
                        callback(data);
                    }
                );
            };
        },
    ]
);
